import { toggleHeader } from "../include/module";
import { drawFooterCurve } from "../include/module";
import { drawUnderlayerCurve } from "../include/module";
import { toggleBox } from "../include/module";
import { visibleTop } from "../include/module";
import { anchorAdjust } from "../include/module";
import { anchorLink } from "../include/module";



(() => {

  toggleHeader();

  drawUnderlayerCurve();

  drawFooterCurve();

  toggleBox();

  visibleTop();

  anchorAdjust();

  anchorLink();

})();



// WEBPACK FOOTER //
// script.js